import React from 'react';
import classNames from 'classnames';

const ThemePush = (props) => {
  const classes = classNames({
    'c-theme-push': true,
    'c-theme-push--faq': props.Theme === 'faq',
    'c-theme-push--forum': props.Theme === 'forum',
    'c-theme-push--story': props.Theme === 'story',
    'c-theme-push--office': props.Theme === 'office',
  });

  const columns = classNames({
    columns: true,
    'medium-6 large-3': props.numOfThemeBlocks > 3,
    'medium-6 large-4': props.numOfThemeBlocks === 3,
    'medium-12 large-4': props.numOfThemeBlocks === 3 && props.index === 2,
    'medium-6 large-6': props.numOfThemeBlocks === 2,
    'small-12': props.numOfThemeBlocks === 1,
  });

  return (
    <div className={columns}>
      <a className={classes} href={props.Href}>
        <div className="c-theme-push__box">
          <div className="c-theme-push__content">
            <div className="c-theme-push__content__inner">
              <div className="c-theme-push__text-wrapper">
                <h3 className="c-theme-push__heading">{props.Heading}</h3>
                {props.Description && (
                  <p className="c-theme-push__text">{props.Description}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ThemePush;
